/** Formats an ISO timestamp as e.g. "Feb 18, 2026"; returns the raw input if unparseable. */
export function formatDate(iso: string): string {
  const date = new Date(iso);
  return Number.isNaN(date.getTime())
    ? iso
    : date.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
}
